import React, { Component } from 'react';
import { Modal, Select, Input, message, Icon,Button , DatePicker } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import { xToken } from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import { renderRow } from '../../../common/combineTable';
import moment from 'moment';

const { MonthPicker } = DatePicker
const MatchTypeList = [
    { label: '首次', value: '首次' },
    { label: '增加适应症', value: '增加适应症' },
    { label: '其他', value: '其他' },
]
const textList = [
    { label: '审批中', value: '审批中' },
    { label: '已通过', value: '已通过' },
    { label: '未通过', value: '未通过' },
    { label: '未知', value: '未知' },
]
const dateFormat = "YYYY-MM-DD";
const Option = Select.Option;


class Milestone extends Component {
    state = {
        params: {},
        visible: false,
        secondLineName:null,
        canCreat:null,
        seveParams:{},
        investigationName:null,
        data:[]
    }

    show = ( record ) =>{
        this.setState({
            visible:true,
            record,
            investigationName:record.investigationName,
            investigationId:record.investigationId,
            canEditMilepost:record.canEditMilepost,
        },this.getInvMilepostList);
    }

    getInvMilepostList = () =>{
        const { investigationId } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.nationalverification.getInvMilepostList,
            data: {investigationId},
            dataType: 'json',
            doneResult: res => {
                const {datas} =res;
                datas.forEach(el =>{
                    el.canEdit = true;
                })
                this.setState({data:datas})
            },
            errorResult: err => {
                console.log(err);
            }
        };
        $.sendRequest(options);
    }

    submit = () =>{
        const { secondLineName } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.member.sendSecondLineChangeMessage,
            data: {secondLineName},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
            },
            errorResult: err => {
                console.log(err);
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString,key)=>{
        const { seveParams } = this.state;
        seveParams[key] = dateString;
        this.setState({siteList})
    }

    hide = () => {
        this.setState({
            visible: false,
        });
        this.props.loadData();
    }

    editSwitch = ( canEdit , index ) =>{
        const {data} = this.state;
        if(canEdit){
            data[index].canEdit = !canEdit;
            this.setState({data})
            return
        }
        if(!canEdit){
            if(index == 13 && !data[index].remark){
                message.error('请选择CED审批通过的备注')
                return
            }
            data[index].canEdit = !canEdit;
            this.save(index);
            this.setState({data})
        }
    }
    save = (index)=>{
        const { data , investigationId } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.nationalverification.saveInvestigationMilepost,
            data: {...data[index],investigationId},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
            errorResult: err => {
                console.log(err);
            }
        };
        $.sendRequest(options);
    }

    handleTextChange = (value , index)=>{
        const {data} = this.state;
        data[index].remark = value
        this.setState({data})
    }

    handleTableDateChange = (date, dateString, key ,index)=>{
        const { data } = this.state;
        data[index][key] = dateString
        this.setState({data})
    }

    handleSelectChange = (value,key) =>{
        const { data } = this.state;
        data[index][key] = value
        this.setState({data})
    }

    clearInput = (index) =>{
        const {data} = this.state;
        data[index].remark = null
        this.setState({data})
    }

    getColumns = () => {
        const {canEditMilepost, data} = this.state
        const textOption = textList.map(e =>{return <Option value={e.value} key={e.value}>{e.label}</Option>})
        const columns = [{
            title: '序号',
            dataIndex: 'sortNum',
            key: 'sortNum',
            width: 40,
            render: (value, row, index) => renderRow(value, row, index ,'sortNum', data)
        }, {
            title: '重要里程碑',
            dataIndex: 'milepostName',
            key: 'milepostName',
            width: 160,
            render: (value, row, index) => renderRow(value, row, index ,'milepostName', data)
        }, {
            title: '计划时间',
            dataIndex: 'planTime',
            key: 'planTime',
            width: 140,
            render: (text , record ,index) => {
                const { canEdit , milepostName} = record;
                const canEditPlanTime = milepostName == '所有中心启动' || milepostName == '中期数据清理完成' || milepostName == '所有受试者随访完成出组(LPLV)' || milepostName == '项目数据库锁库(DBL)' || milepostName == '所有中心关闭' || milepostName == 'CDE审批通过';
                return (!canEdit && canEditPlanTime)?
                    <div style={{display: 'inline-block'}}>
                        {
                            text?
                            < MonthPicker
                                placeholder="请选择月份"
                                style={{ width: 120 }}
                                value={moment(text)}
                                onChange={(date , dateString) => this.handleTableDateChange(date , dateString , 'planTime' ,index)}
                            />:
                            < MonthPicker
                                placeholder="请选择月份"
                                style={{ width: 120 }}
                                onChange={(date , dateString) => this.handleTableDateChange(date , dateString , 'planTime' ,index)}
                            />
                        }
                    </div>
                :text
            }
        }, {
            title: '实际时间', 
            dataIndex: 'actualTime',
            key: 'actualTime',
            width: 140,
            render: (text , record ,index) => {
                const { canEdit , milepostName} = record;
                const canEditPlanTime = milepostName == '中期数据清理完成' || milepostName == '项目数据库锁库(DBL)' || milepostName == 'CDE审批通过';
                return (!canEdit && canEditPlanTime)?
                    <div style={{display: 'inline-block'}}>
                        {   
                            text?
                            < MonthPicker
                                placeholder="请选择月份"
                                style={{ width: 120 }}
                                value={moment(text)}
                                disabledDate ={(current)=> {return current && current.valueOf() > Date.now()}}
                                onChange={(date , dateString) => this.handleTableDateChange(date , dateString , 'actualTime' ,index)}
                            />:
                            < MonthPicker
                                placeholder="请选择月份"
                                style={{ width: 120 }}
                                disabledDate ={(current)=> {return current && current.valueOf() > Date.now()}}
                                onChange={(date , dateString) => this.handleTableDateChange(date , dateString , 'actualTime' ,index)}
                            />
                        }
                    </div>
                :text
            }
        }, {
            title: '研究中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 160,
        }, {
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 100,
        }, {
            title: '是否达成',
            dataIndex: 'achievedShow',
            key: 'achievedShow',
            width: 80,
        }, {
            title: '备注 ',
            dataIndex: 'remark',
            key: 'remark',
            width: 140,
            render: (text , row ,index) => {
                const _row = row;
                const _index = index;
                const _this = this;
                function getText (record ,index){
                    const { canEdit ,milepostName} = record;
                    return (!canEdit && milepostName == 'CDE审批通过')?
                    <div style={{display: 'inline-block'}}>
                        <Select
                            style={{ width: 120 }}
                            defaultValue={'审批中'}
                            value ={text}
                            onChange={value => _this.handleTextChange(value ,index)}
                        >
                            {textOption}
                        </Select>
                    </div>
                    :!canEdit?
                        <div style={{display: 'inline-block'}}>
                            <Input
                                placeholder="请输入"
                                style={{ width: 120 }}
                                value={text}
                                suffix={
                                    text?
                                    <Icon type="close-circle" onClick={()=>_this.clearInput(index)} />:null
                                }
                                onChange={e => _this.handleTextChange(e.target.value ,index)}
                            />
                        </div>
                    :(milepostName == 'CDE审核通过' && text == '')?
                        ()=>{_this.handleTextChange('审批中' ,index)}
                    :text
                }
                return renderRow(getText(_row,_index), row, index ,'sortNum', data)
            }
        }];
        if(canEditMilepost){
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                fixed: 'right',
                width: 80,
                render: (value, row, index) =>{
                    const _row = row;
                    const _index = index;
                    const _this = this;
                    function getOperation (row, index){
                        const { canEdit } = row;
                        return (
                            <span>
                                {
                                    canEdit &&
                                    <span>
                                        <a onClick={() => _this.editSwitch(canEdit , index)}>修改</a>
                                    </span>
                                }
                                {
                                    !canEdit &&
                                    <span>
                                        <a onClick={() => _this.editSwitch(canEdit , index)}>保存</a>
                                    </span>
                                }
                            </span>
                        );
                    }
                    return renderRow(getOperation(_row,_index), row, index ,'sortNum', data)
                }
            })
        }
        return columns;
    };

    render() {
        const { visible , seveParams , data,investigationName } = this.state;
        return (
            <Modal
                title={`里程碑登记`}
                visible={visible}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={1200}
                bodyStyle={{maxHeight:"800px"}}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >   
                <div style={{marginBottom:'10px'}}>项目简称：{investigationName}</div>
                <TableC
                    columns={this.getColumns()}
                    data={data}
                />
            </Modal>
        )
    }
}

export default Milestone;


// WEBPACK FOOTER //
// ./src/components/qualityManagement/ImportantMilestone/components/Milestone.js